import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import 'moment-timezone';
import { calculateAgeParse } from '../Utils/Patient';

const PDFTranscription = async (data) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        }
    };

    console.log("COMINGPDFTENSCRIPTION", data);
    const name = data.typeDocument + '-' + data.documentNumber + ' ' + data.fullname;
    const supportDoc = data.suportDoc;

    const header = {
        margin: [40, -10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(data.urlLogo),
                    fit: [150, 75],
                },
                {
                    layout: 'noBorders',
                    table: {
                        body: [
                            [{ text: data.profile.nombre, style: 'head', bold: true, alignment: 'center' }],
                            [{ text: 'Dirección: ' + data.profile.direccion.direccion + ' ' + 'Teléfono:' + data.profile.telefono1, style: 'textStyle', bold: true, alignment: 'center' }],
                            [{ text: 'NIT: : ' + data.profile.nit, style: 'head', bold: true, alignment: 'center' }]
                        ]
                    },
                }],
            ],
        },
    };

    let tableBodySignatures = [
        {
            // auto-sized columns have their widths based on their content  
            unbreakable: true,
            layout: 'headerLineOnly',
            border: [false, false, false, false],
            table: {
                widths: [125],
                headerRows: 1,
                alignment: 'center',
                body: [
                    [{
                        image: await getBase64ImageFromURL(data.urlDoctorFirm),
                        fit: [100, 25],
                        alignment: 'center'
                    }],
                    [{ text: data.nameDoctor + '\n' + data.specialtyDoctor + '\nREG-' + data.medicalRegister, style: 'signature', fontSize: 7 }]
                ]
            },
        },
    ];

    for(let i = 0; i<supportDoc.length; i++){
        let supportDocInfo = supportDoc[i];
        let firmUrl = data.firmDoctorSupport[i];

        //if(data.medicalRegister === "49722909" && data.suportDoc !== null){
        if(data.suportDoc !== null){
            tableBodySignatures.push({
                unbreakable: true,
                layout: 'headerLineOnly',
                border: [false, false, false, false],
                table: {
                    widths: [125],
                    headerRows: 1,
                    alignment: 'center',
                    body: [
                        [{
                            image: await getBase64ImageFromURL(firmUrl),
                            fit: [100, 25],
                            alignment: 'center'
                        }],
                        [{  text: supportDocInfo.titulo + " " + supportDocInfo.nombres + " " + supportDocInfo.apellido1 + '\n' + supportDocInfo.especialidad + '\nREG-' + supportDocInfo.reg_medico, 
                        style: 'signature', fontSize: 7 }]
                    ]
                },
            })
        }
    }

    const signatures = [
        {
            // auto-sized columns have their widths based on their content  
            unbreakable: true,
            margin: [10, 20, 10, 0],
            layout: {
                paddingTop: function (index, node) {
                    applyVerticalAlignment(node, index, 'bottom');
                    return 0;
                },
                defaultBorder: false,
            },
            table: {
                widths: ['*', '*', '*'],
                headerRows: 1,
                body: [
                        tableBodySignatures
                    //  {
                    //     // auto-sized columns have their widths based on their content  
                    //     unbreakable: true,
                    //     layout: 'headerLineOnly',
                    //     border: [false, false, false, false],
                    //     table: {
                    //         widths: [200],
                    //         headerRows: 1,
                    //         alignment: 'center',
                    //         body: [
                    //             [{
                    //                 image: await getBase64ImageFromURL(data.urlDoctorFirm),
                    //                 fit: [100, 100],
                    //                 alignment: 'center'
                    //             }],
                    //             [{ text: data.nameDoctor + '\n' + data.specialtyDoctor + '\nREG-' + data.medicalRegister, style: 'signature' }]
                    //         ]
                    //     },
                    // },
                    // data.medicalRegister === "49722909" && data.suportDoc !== null ?
                    // {
                    //     // auto-sized columns have their widths based on their content  
                    //     unbreakable: true,
                    //     layout: 'headerLineOnly',
                    //     border: [false, false, false, false],
                    //     table: {
                    //         widths: [200],
                    //         headerRows: 1,
                    //         alignment: 'center',
                    //         body: [
                    //             [{
                    //                 image: await getBase64ImageFromURL(data.firmDoctorSupport),
                    //                 fit: [100, 100],
                    //                 alignment: 'center'
                    //             }],
                    //             [{ text: supportDoc.titulo + " " + supportDoc.nombres + " " + supportDoc.apellido1 + '\n' + supportDoc.especialidad + '\nREG-' + supportDoc.reg_medico, style: 'signature' }]
                    //         ]
                    //     },
                    // } : null
                ]
            },
        }
    ];

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        /*header: header,*/
        footer: function (currentPage, pageCount) {
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'foter' }, { text: name, style: 'foter' }, { text: 'Fecha Impresión: ' + data.today, style: 'foter' }],
                    ]
                },
                layout: 'noBorders',
                margin: [20, 0, 0, 5],
            };
        },
        content: [
            header,
            {
                margin: [0, 0, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    headerRows: 1,

                    widths: ['auto', '*'],
                    body: [
                        [
                            { text: 'Admisión: ', style: 'textStyle', bold: true },
                            { text: data.id_admision, style: 'textStyle' },
                        ],
                    ]
                },
            },
            {
                table: {
                    headerRows: 1,
                    widths: [520],
                    body: [
                        [''],
                        ['']
                    ]
                },
                layout: 'headerLineOnly'
            },
            {
                margin: [0, 0, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: ['auto', '*', 'auto', '*', 'auto', '*'],
                    border: [true, false, true, false],
                    body: [
                        [{ text: 'Nombre ', bold: true, style: 'textStyle' }, { text: data.fullname, style: 'textStyle' }, { text: 'Identificación', bold: true, style: 'textStyle' }, { text: data.documentNumber, style: 'textStyle' }, { text: 'Tipo', bold: true, style: 'textStyle' }, { text: data.typeDocument, style: 'textStyle' }],
                        [{ text: 'Fecha de Nacimiento ', bold: true, style: 'textStyle' }, { text: moment(data.birthday).format("DD/MM/YYYY"), style: 'textStyle' }, { text: 'Edad ', bold: true, style: 'textStyle' }, { text: calculateAgeParse(data.birthday), style: 'textStyle' }, { text: 'Genero', bold: true, style: 'textStyle' }, { text: data.gender, style: 'textStyle' }],
                        [{ text: 'Dirección ', bold: true, style: 'textStyle' }, { text: data.address, style: 'textStyle' }, { text: 'Municipio ', bold: true, style: 'textStyle' }, { text: data.id_ciudad_paciente !== undefined ? data.id_ciudad_paciente + " - " + data.city : data.city, style: 'textStyle' }, { text: 'Celular: ', bold: true, style: 'textStyle' }, { text: data.celular, style: 'textStyle' }],
                        [{ text: 'Entidad ', bold: true, style: 'textStyle' }, { text: data.nameThird + " - " + data.nitThird, style: 'textStyle' }, { text: 'Regimen ', bold: true, style: 'textStyle' }, { text: data.regime, style: 'textStyle' }, { text: 'Fecha Procedimiento', bold: true, style: 'textStyle' }, { text: moment(data.fecha_admision).format("DD/MM/YYYY"), style: 'textStyle' }],
                    ]
                }
            },
            {
                table: {
                    headerRows: 1,
                    widths: [520],
                    body: [
                        [''],
                        ['']
                    ]
                },
                layout: 'headerLineOnly'
            },
            {
                margin: [0, 0, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    headerRows: 1,

                    widths: ['auto', 'auto', '*'],
                    body: [
                        [
                            { text: moment(data.fecha_admision).format("DD/MM/YYYY"), style: 'textStyle' },
                            { text: '| CUPS: ' + data.codigoService, style: 'textStyle', bold: true },
                            { text: data.nameService, style: 'textStyle' },
                        ],
                    ]
                },
            },
            {
                margin: [0, 20, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    widths: ['*'],
                    body: [
                        [
                            { text: data.transcription, style: 'textStyle', border: [false, false, false, false] }
                        ]
                    ]
                },
            },
            {
                // auto-sized columns have their widths based on their content                                       
                columns: signatures,
                alignment: 'justify',
                columnGap: 10
            },
        ],
        styles: {
            head: {
                fontSize: 9,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },
            tableheader: {
                fontSize: 9,
                bold: true,
                font: 'OpenSans'
            },
            textStyle: {
                fontSize: 8,
                font: 'OpenSans'
            },
            signature: {
                fontSize: 9,
                alignment: 'center',
                bold: true,
                font: 'OpenSans'
            },
            foter: {
                margin: 10,
                fontSize: 7,
                font: 'OpenSans'
            },
        }
    };

    if (data.printInnerWindow) {
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
        pdfDocGenerator.getDataUrl(function (outDoc) {
            document.getElementById('pdfV').src = outDoc;
        });
    } else {
        pdfMake.createPdf(documentDefinition).open();
    }
}


function findInlineHeight(cell, maxWidth, usedWidth = 0) {
    function mapTableBodies(innerTableCell) {
        const inlineHeight = findInlineHeight(
            innerTableCell,
            maxWidth,
            usedWidth
        );
    
        usedWidth = inlineHeight.width;
        return inlineHeight.height;
    }
    let calcLines = (inlines) => {
        if (!inlines)
            return {
                height: 0,
                width: 0,
            };
        let currentMaxHeight = 0;
        let lastHadLineEnd = false;
        for (const currentNode of inlines) {
            usedWidth += currentNode.width;
            if (usedWidth > maxWidth || lastHadLineEnd) {
                currentMaxHeight += currentNode.height;
                usedWidth = currentNode.width;
            } else {
                currentMaxHeight = Math.max(currentNode.height, currentMaxHeight);
            }
            lastHadLineEnd = !!currentNode.lineEnd;
        }
        return {
            height: currentMaxHeight,
            width: usedWidth,
        };
    }
    if (cell._offsets) {
        usedWidth += cell._offsets.total;
    }
    if (cell._inlines && cell._inlines.length) {
        return calcLines(cell._inlines);
    } else if (cell.stack && cell.stack[0]) {
        return cell.stack.map(item => {
            return findInlineHeight(item, maxWidth);
        }).reduce((prev, next) => {
            return {
                height: prev.height + next.height,
                width: Math.max(prev.width + next.width)
            };
        });
    } else if (cell.table) {
        let currentMaxHeight = 0;
        for (const currentTableBodies of cell.table.body) {
            const innerTableHeights = currentTableBodies.map(mapTableBodies);
            currentMaxHeight = Math.max(...innerTableHeights, currentMaxHeight);
        }
        return {
            height: currentMaxHeight,
            width: usedWidth,
        };
    } else if (cell._height) {
        usedWidth += cell._width;
        return {
            height: cell._height,
            width: usedWidth,
        };
    }

    return {
        height: null,
        width: usedWidth,
    };
}

function applyVerticalAlignment(node, rowIndex, align, manualHeight = 0) { // New default argument
    const allCellHeights = node.table.body[rowIndex].map(
        (innerNode, columnIndex) => {
            if (innerNode._span) return null
            const calcWidth = [...Array(innerNode.colSpan || 1).keys()].reduce((acc, i) => {
                return acc + node.table.widths[columnIndex + i]._calcWidth
            }, 0)
            const mFindInlineHeight = findInlineHeight(innerNode, calcWidth, 0, rowIndex, columnIndex)
            return mFindInlineHeight.height;
        }
    );
    const maxRowHeight = manualHeight ? manualHeight[rowIndex] : Math.max(...allCellHeights); // handle manual height
    node.table.body[rowIndex].forEach((cell, ci) => {
        if (allCellHeights[ci] && maxRowHeight > allCellHeights[ci]) {
            let topMargin;

            let cellAlign = align;
            if (Array.isArray(align)) {
                cellAlign = align[ci];
            }

            if (cellAlign === 'bottom') {
                topMargin = maxRowHeight - allCellHeights[ci];
            } else if (cellAlign === 'center') {
                topMargin = (maxRowHeight - allCellHeights[ci]) / 2;
            }

            if (topMargin) {
                if (cell._margin) {
                    cell._margin[1] = topMargin;
                } else {
                    cell._margin = [0, topMargin, 0, 0];
                }
            }
        }
    });
}

function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default PDFTranscription;